import React from "react";

const Button = ({ text, onClick, already }) => {
  return (
    <div className="col-md-6 d-flex justify-content-center mt-3">
      <button
        className={`btn fw-bold ${
          text === "Approve Request For Manager"
            ? "btnSend "
            : `${
                text === "Already Sent To Manager"
                  ? "card-bg   backBorder"
                  : " btnViewR"
              }`
        }`}
        onClick={onClick}
      >
        {text}
      </button>
    </div>
  );
};

export default Button;
